import React from 'react';
import styled from 'styled-components';
import startCase from 'lodash/startCase';

import HistoryList from 'components/common/HistoryList';

import { SUBSCRIPTION } from 'constants/status';

import Select from '@twicapp/ui/components/Select';
import Option from '@twicapp/ui/components/Option';
import Headline1 from '@twicapp/ui/components/Headline1';
import Skeleton from '@twicapp/ui/components/legacy/Skeleton';

const Container = styled.div`
  width: 100%;
`;

const PageTitle = styled(Headline1)`
  margin-bottom: 30px;
`;

const FilterContainer = styled.div`
  margin-bottom: 40px;
`;

const FilterDropdown = styled(Select)`
  width: 138px;
`;

const ProfileSubscriptionList = ({
  subscriptions,
  has_more_subscriptions,
  is_subscriptions_loading,
  onNextPage,
  employee,
  status,
  applyFilters,
}: $TSFixMe) => (
  <Container>
    <PageTitle>Subscriptions</PageTitle>
    <FilterContainer>
      <FilterDropdown
        label="Status"
        name="status"
        value={status}
        placeholder="Filter"
        onChange={(value: $TSFixMe) => {
          applyFilters({
            status: value === 'all' ? null : value.toLowerCase(),
          });
        }}
      >
        {Object.values(SUBSCRIPTION).map((option) => (
          <Option key={option} value={option}>
            {startCase(option)}
          </Option>
        ))}
      </FilterDropdown>
    </FilterContainer>

    {is_subscriptions_loading ? (
      <Skeleton />
    ) : (
      <HistoryList
        items={subscriptions}
        has_more_items={has_more_subscriptions}
        type={'subscription'}
        onNextPage={onNextPage}
        employee={employee}
        description={'Add and manage your gym subscription with Twic'}
      />
    )}
  </Container>
);

export default ProfileSubscriptionList;
